(function () {
  'use strict';

  var ROOT_CLASS = 'magnetic-enabled';

  if (!document.documentElement.classList.contains(ROOT_CLASS)) return;

  var fineQuery = window.matchMedia('(any-pointer: fine)');
  var motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

  // Pointer-based effect only: skip touch/coarse pointers and reduced-motion users.
  if (!fineQuery.matches || motionQuery.matches) return;

  // Individual magnetic elements + each item inside a magnetic group (social icons).
  var SELECTOR = '[data-magnetic], [data-magnetic-group] .social-media__item';
  var ACTIVE_CLASS = 'is-magnetic-active';

  var STRENGTH = 0.2; // fraction of the cursor offset the icon follows
  var MAX_OFFSET = 12; // px cap so the icon never drifts too far

  var active = null;

  function clamp(value, min, max) {
    return value < min ? min : value > max ? max : value;
  }

  function reset(el) {
    if (!el) return;
    el.classList.remove(ACTIVE_CLASS);
    el.style.transform = '';
  }

  function onMove(event) {
    var el = event.target && event.target.closest ? event.target.closest(SELECTOR) : null;

    if (el !== active) {
      reset(active);
      active = el;
      if (active) active.classList.add(ACTIVE_CLASS);
    }

    if (!active) return;

    var rect = active.getBoundingClientRect();
    var dx = clamp((event.clientX - (rect.left + rect.width / 2)) * STRENGTH, -MAX_OFFSET, MAX_OFFSET);
    var dy = clamp((event.clientY - (rect.top + rect.height / 2)) * STRENGTH, -MAX_OFFSET, MAX_OFFSET);

    active.style.transform = 'translate3d(' + dx + 'px,' + dy + 'px,0)';
  }

  function release() {
    reset(active);
    active = null;
  }

  function unbind() {
    document.removeEventListener('pointermove', onMove);
    document.removeEventListener('pointerdown', onMove);
    window.removeEventListener('blur', release);
  }

  document.addEventListener('pointermove', onMove, { passive: true });
  document.addEventListener('pointerdown', onMove, { passive: true });
  window.addEventListener('blur', release);

  var onMotionChange = function () {
    if (motionQuery.matches) {
      release();
      unbind();
    }
  };
  if (motionQuery.addEventListener) motionQuery.addEventListener('change', onMotionChange);
  else if (motionQuery.addListener) motionQuery.addListener(onMotionChange);
})();
